<!--
  ExamTrendChartCard — Pineapple 톤
  · 외부 카드 크롬 제거 (Pineapple ACard 안에서 호출됨)
  · 노란 라인 + 검은 라인, fill 그라디언트, Pretendard/JetBrains Mono 폰트
-->
<template>
  <div class="p-line">
    <div class="p-line__legend">
      <span class="p-line__legend-item">
        <span class="p-line__legend-dot" :style="{ background: palette[0] }" />
        시험 실시 횟수
      </span>
      <span v-if="hasAvgScores" class="p-line__legend-item">
        <span class="p-line__legend-dot" :style="{ background: palette[1] }" />
        평균 점수
      </span>
    </div>
    <div class="p-line__chart">
      <canvas :id="chartId" />
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  name: 'ExamTrendChartCard',
  props: {
    chartData: {
      type: Object,
      required: true,
      default: () => ({
        labels: [],
        datasets: [
          { label: '시험 실시', data: [] },
          { label: '평균 점수', data: [] },
        ],
      }),
    },
  },
  data() {
    return {
      chartId: `pine-line-${Math.random().toString(36).slice(2, 9)}`,
      palette: ['#FFC93C', '#1F1B14'],
      instance: null,
    };
  },
  computed: {
    hasAvgScores() {
      return this.chartData.datasets[1]?.data?.length > 0;
    },
  },
  watch: {
    chartData: { deep: true, handler() { this.renderChart(); } },
  },
  mounted() { this.renderChart(); },
  beforeUnmount() { if (this.instance) this.instance.destroy(); },
  methods: {
    renderChart() {
      const el = document.getElementById(this.chartId);
      if (!el) return;
      const ctx = el.getContext('2d');
      const existing = Chart.getChart(this.chartId);
      if (existing) existing.destroy();

      const fill = ctx.createLinearGradient(0, 0, 0, 240);
      fill.addColorStop(0, 'rgba(255, 201, 60, 0.32)');
      fill.addColorStop(1, 'rgba(255, 201, 60, 0)');

      const datasets = [{
        label: this.chartData.datasets[0].label,
        data: this.chartData.datasets[0].data,
        borderColor: this.palette[0],
        backgroundColor: fill,
        borderWidth: 2.5,
        tension: 0.35,
        pointRadius: 4,
        pointBackgroundColor: this.palette[0],
        pointBorderColor: this.palette[1],
        pointBorderWidth: 1.5,
        fill: true,
      }];
      if (this.hasAvgScores) {
        datasets.push({
          label: this.chartData.datasets[1].label,
          data: this.chartData.datasets[1].data,
          borderColor: this.palette[1],
          backgroundColor: 'transparent',
          borderWidth: 2,
          tension: 0.35,
          pointRadius: 3,
          pointBackgroundColor: this.palette[1],
          fill: false,
          borderDash: [4, 3],
        });
      }

      this.instance = new Chart(ctx, {
        type: 'line',
        data: { labels: this.chartData.labels, datasets },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: '#1F1B14',
              titleColor: '#FFC93C',
              bodyColor: '#F6EFDB',
              padding: 10,
              cornerRadius: 8,
            },
          },
          scales: {
            x: {
              grid: { display: false, drawBorder: false },
              ticks: {
                color: '#9C9486',
                font: { family: 'JetBrains Mono', size: 11 },
              },
            },
            y: {
              grid: { color: '#F0E8D2', drawBorder: false },
              ticks: {
                color: '#9C9486',
                font: { family: 'JetBrains Mono', size: 11 },
              },
              beginAtZero: true,
            },
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_pineapple.scss';

.p-line {
  font-family: $p-font-body;

  &__legend {
    display: flex;
    gap: 16px;
    margin-bottom: 12px;
  }
  &__legend-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 600;
    color: $p-ink2;
  }
  &__legend-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  &__chart {
    height: 240px;
    position: relative;
  }
}
</style>
